<template>
    <div class="Program">
        <div class="row record-section-row">
            <div class="col col-md-4">
                <h4>Running Summary:</h4>
                <TextAreaEditor v-bind:old-value="FamilyRecordData.Family.RunningSummary"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="Running Summary"
                                property-name="RunningSummary"
                                update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                required="false"
                                :global-update="true" />
            </div>
            <div class="col col-md-4">
                <h4>Adoption Match Preferences:</h4>
                <TextAreaEditor v-bind:old-value="FamilyRecordData.Family.AdoptionMatchPreferences"
                                v-bind:record-id="FamilyRecordData.Family.Id"
                                v-bind:edit-mode="EditMode"
                                data-label="Adoption Match Preferences"
                                property-name="AdoptionMatchPreferences"
                                update-method="Foster/ResourceFamily/UpdateFosterResourceFamily"
                                required="false"
                                :global-update="true" />
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col col-md-12">
                <FamilyStatusEditor :chart-id="FamilyRecordData.Family.Id"
                                    :global-update="true"
                                    :sub-program-id="FamilyRecordData.FamilyProgramMembership.SubProgramID"
                                    :edit-mode="EditMode" />

            </div>
        </div>
        <div class="row record-section-row">
            <div class="col col-md-12">
                <FamilyApprovalTimeline :record-id="FamilyRecordData.Family.Id"
                                        edit-permission-requirement=""
                                        view-permission-requirement=""
                                        :edit-mode="EditMode"
                                        :family-record-data="FamilyRecordData" />

            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Family Program:</h4>
                <div>
                    <SingleMembershipEditor :fields="[{name: 'SubProgram.Name', title: 'Program'},{name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                            :field-data="FamilyRecordData.FamilyProgramMemberships"
                                            :edit-mode="EditMode"
                                            select-label="Programs:"
                                            options-type="API"
                                            options-method="Foster/ResourceFamily/GetSubPrograms"
                                            :options-method-record-id="FamilyRecordData.Family.Id"
                                            add-record-method="Core/EmployeeCaseload/AddFirstRFSFamilyMembership"
                                            add-record-record-property-name="FosterFamilyID"
                                            :add-record-additional-payload="{FosterFamilyID: FamilyRecordData.Family.Id, SubProgramID: FamilyRecordData.FamilyProgramMembership.SubProgramID, EffectiveDate: StartDate}"
                                            add-record-modal-title="Add Initial Program"
                                            transfer-record-method="Foster/ResourceFamily/TransferFamilyBetweenSubPrograms"
                                            transfer-record-record-property-name="SubProgramID"
                                            :transfer-record-additional-payload="{FosterFamilyID: FamilyRecordData.Family.Id, EmployeeID: '$parent.UserPrivateProfile.EmployeeID'}"
                                            transfer-record-modal-title="Transfer Programs"
                                            transfer-record-effective-date-property-name="EffectiveDate"
                                            delete-record-method="Foster/ResourceFamily/RevertFamilySubPrograms"
                                            :delete-record-additional-payload="{Id: FamilyRecordData.Family.Id}"
                                            delete-record-modal-title="Delete Current Program"
                                            delete-record-modal-text="NOTICE: You are about to delete this family's current program.  If there was a previous program assigned, the family will be re-assigned to that program." />
                </div>
            </div>
        </div>
        <div class="row record-section-row" v-if="CheckPermission('Administrator')">
            <div class="col col-md-12" v-if="FamilyRecordData.Family.ApprovalPhases">
                <FamilyPhaseEditor :record-id="FamilyRecordData.Family.Id"
                                   :table-data="FamilyRecordData.Family.ApprovalPhases"
                                   edit-permission-requirement=""
                                   view-permission-requirement=""
                                   :edit-mode="EditMode"
                                   :family-record-data="FamilyRecordData" />

            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import FamilyPhaseEditor from './FamilyPhaseEditor.vue';
    import FamilyStatusEditor from './FamilyStatusEditor.vue';
    import FamilyApprovalTimeline from './FamilyApprovalTimeline.vue';
    import TextAreaEditor from '../../../Core/ItemEditors/TextAreaEditor.vue';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import SingleMembershipEditor from '../../../Core/ItemEditors/SingleMembershipEditor';

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';

    export default {
        name: 'Program',
        props: [
            'FamilyRecordData'
        ],
        data: function () {
            return {
                EditMode: false,
                YesOrNoOption: [
                    {
                        text: "Yes",
                        value: true
                    },
                    {
                        text: "No",
                        value: false
                    }
                ]
            };
        },
        methods: {
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            FamilyPhaseEditor,
            flatPickr,
            TextAreaEditor,
            EditMode,
            SelectEditor,
            FamilyApprovalTimeline,
            FamilyStatusEditor,
            SingleMembershipEditor
        },
        mounted() {

        },
        computed: {
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.FamilyRecordData.FamilyProgramMembership.SubProgramID.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>